/* eslint-disable */
/**
 * TidslinjeListe — Dato-ikon + tekst, nyeste øverst, scroll
 *
 * Props:
 *   items   Array<{ id, dato, titel, tekst?, farve?, ikon? }>
 *           dato = ISO-streng
 *   maxHøjde  number  — max-height i px (default 320)
 *   tomTekst  string
 *   loading   bool
 *   style     obj
 */

import React from 'react';
import { KANT, TEKST, STATUS, RADIUS } from './tokens';
import TomTilstand from './TomTilstand';

function formatDato(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('da-DK', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

export default function TidslinjeListe({ items = [], maxHøjde = 320, tomTekst = 'Ingen aktivitet', loading = false, style = {} }) {
  if (loading) {
    return <div style={{ color: TEKST.sekundær, fontSize: 13, padding: '12px 0' }}>Henter…</div>;
  }

  if (!items.length) {
    return (
      <TomTilstand
        titel={tomTekst}
        besked="Aktivitet vises her, når den registreres."
        ikon="○"
        badge="LIVE"
        style={style}
      />
    );
  }

  return (
    <div style={{ maxHeight: maxHøjde, overflowY: 'auto', paddingRight: 4, ...style }}>
      {items.map((item, i) => {
        const fv = item.farve || STATUS.konfigureret;
        return (
          <div
            key={item.id || i}
            style={{
              display:  'flex',
              gap:      12,
              padding:  '8px 2px',
              borderBottom: i < items.length - 1 ? `1px solid ${KANT.fin}` : 'none',
            }}
          >
            {/* Tidslinje-streg + ikon */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0 }}>
              <div style={{
                width:        28,
                height:       28,
                borderRadius: '50%',
                background:   `${fv}18`,
                border:       `1px solid ${fv}40`,
                display:      'flex',
                alignItems:   'center',
                justifyContent: 'center',
                fontSize:     13,
                flexShrink:   0,
                color:        fv,
              }}>
                {item.ikon || '●'}
              </div>
              {i < items.length - 1 && (
                <div style={{ width: 1, flex: 1, minHeight: 12, background: KANT.standard, marginTop: 3 }} />
              )}
            </div>

            {/* Indhold */}
            <div style={{ flex: 1, paddingBottom: 6 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap', marginBottom: 2 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: TEKST.primær }}>{item.titel}</span>
                <span style={{ fontSize: 10, color: TEKST.sekundær, marginLeft: 'auto', whiteSpace: 'nowrap' }}>
                  {formatDato(item.dato)}
                </span>
              </div>
              {item.tekst && (
                <div style={{ fontSize: 12, color: TEKST.sekundær, lineHeight: 1.5 }}>
                  {item.tekst}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
